import React from 'react'
import { array, string } from 'prop-types'
import { css } from '@emotion/react'

import Column from './Column'

const linksCss = css({
  display: 'flex',
  paddingBottom: '32px',
  margin: '0',

  '@media (max-width: 1035px)': {
    display: 'grid',
    gridTemplateRows: 'repeat(2, 1fr)',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gridGap: '30px',
  },

  '@media (max-width: 400px)': {
    gridTemplateRows: 'repeat(3, 1fr)',
    gridTemplateColumns: 'repeat(2, 1fr)',
    width: '100%',
  },
})

const footerLinks = [
  {
    label: 'Product',
    list: [
      { label: 'Pricing', route: '/pricing/' },
      { label: 'LiveChat Benefits', route: '/benefits/' },
      { label: 'Tour', route: '/tour/' },
      { label: 'Features', route: '/features/' },
      { label: 'Lead Generation', route: '/lead-generation/' },
      { label: 'ChatBot', route: '/chatbot/' },
      { label: 'App', route: '/app/' },
    ],
  },
  {
    label: 'Customers',
    list: [
      { label: 'Customers', route: '/customers/' },
      {
        label: 'Case Studies',
        route: '/customers/customer-stories/',
      },
      { label: 'Testimonials', route: '/customers/live-chat-reviews/' },
    ],
  },
  {
    label: 'Resources',
    list: [
      { label: 'Blog', route: '/success/' },
      { label: 'Podcasts', route: '/podcast/' },
      { label: 'Benchmark', route: '/benchmark/' },
      { label: 'Typing Speed Test', route: '/typing-speed-test/' },
      { label: 'UTM Builder', route: '/utm-builder/' },
      { label: 'AI Technology', route: '/features/ai/' },
    ],
  },
  {
    label: 'Support',
    list: [
      { label: 'Help Center', route: '/help/' },
      { label: 'Webinars', route: '/webinars/' },
      {
        label: 'Partners Marketplace',
        route: '/marketplace/partners/',
      },
      {
        label: 'Professional Services',
        link: 'https://www.livechat.com/enterprise/professional-business-services/',
      },
      {
        label: 'API & Developers',
        link: process.env.GATSBY_DEVELOPERS_URL,
      },
      {
        label: 'System Status',
        link: 'https://status.livechat.com/',
      },
    ],
  },
  {
    label: 'Company',
    list: [
      { label: 'Contact', route: '/contact/' },
      {
        label: 'Investor Relations',
        link: 'https://investor.text.com/',
      },
      { label: 'Team', link: 'https://text.com/team/' },
      { label: 'About', route: '/features/' },
      {
        label: 'Partner Program',
        link: 'https://partners.livechat.com/',
      },
      { label: 'Press', link: 'https://text.com/press/' },
      {
        label: 'Careers',
        link: 'https://www.livechat.com/careers/',
        newTab: true,
      },
    ],
  },
  {
    label: 'Legal',
    list: [
      {
        label: 'Marketplace Terms',
        route: '/legal/terms/',
      },
      {
        label: 'Terms of Use',
        route: '/legal/terms-of-use/',
      },
      { label: 'Privacy Policy', route: '/legal/privacy-policy/' },
      { label: 'Security', route: '/legal/security/' },
      {
        label: 'GDPR',
        link: 'https://www.livechat.com/legal/for-clients/#privacy-faq',
      },
    ],
  },
]

const Links = ({ links = footerLinks, className }) => {
  return (
    <div css={linksCss} className={className}>
      {links?.map(({ label, list }) => (
        <Column key={label} label={label} list={list} />
      ))}
    </div>
  )
}

Links.propTypes = {
  links: array,
  className: string,
}

export default Links
